import React from 'react';
import { ImageValidationTest } from './ImageValidationTest';
import { ScrollArea } from "@/components/ui/scroll-area";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
export const TestRunner = () => {
  return <div className="p-4 my-[240px]">
      <Tabs defaultValue="image-validation">
        <TabsList>
          <TabsTrigger value="image-validation">Image Validation</TabsTrigger>
        </TabsList>
        <TabsContent value="image-validation">
          <ScrollArea className="h-[600px]">
            <ImageValidationTest />
          </ScrollArea>
        </TabsContent>
      </Tabs>
    </div>;
};